var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWizzAir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 1142,
    viewBox: "0 0 175.748 80.304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b71488",
    d: "M125.681 12.384h50.067l-34.78 44.845h24.864L163.8 69.854h-49.584l33.862-44.844h-22.397z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#482a7f",
    d: "M87.85 5.999h54.469L103.28 55.971h21.433l-10.497 13.883h-40.25l37.441-49.972-26.895-.048z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b71488",
    d: "M81.416 57.18H67.871L77.111 0h13.641zM72.37 62.792c4.789 0 8.708 3.918 8.708 8.756s-3.919 8.756-8.708 8.756c-4.838 0-8.756-3.918-8.756-8.756s3.918-8.756 8.756-8.756z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#482a7f",
    d: "M0 9.191l7.499 60.663h11.513l17.27-34.395 2.563 34.395h11.321L80.255 9.191H63.372L48.859 41.844 46.537 9.191H33.283L17.899 41.844 15.383 9.191z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizzAir);
export default __webpack_public_path__ + "static/media/wizz-air.f2251b936355185adb866a7c3a66638b.svg";
export { ForwardRef as ReactComponent };